import React, { useState } from 'react';

const AdminYoutubeChannelsApi = () => {
  const [formData, setFormData] = useState({
    region: 'KR',
    maxResults: 10,
    categoryId: '',
    searchKeyword: '',
    minSubscribers: '',
    minViews: '',
    sortBy: 'relevance',
    dataSource: 'trending', // 'trending' 또는 'all'
    // 새로운 동적 API 옵션들
    endpoint: 'videos',
    part: 'snippet',
    order: 'relevance',
    videoType: 'video',
    chart: 'mostPopular',
    videoDuration: '',
    videoDefinition: '',
    videoCaption: '',
    videoLicense: '',
    safeSearch: 'moderate',
    relevanceLanguage: '',
    eventType: '',
    channelType: '',
    textFormat: 'html',
    moderationStatus: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const regions = [
    { code: 'KR', name: '한국' },
    { code: 'US', name: '미국' },
    { code: 'JP', name: '일본' },
    { code: 'GB', name: '영국' },
    { code: 'CA', name: '캐나다' },
    { code: 'AU', name: '호주' },
    { code: 'DE', name: '독일' },
    { code: 'FR', name: '프랑스' },
    { code: 'BR', name: '브라질' },
    { code: 'IN', name: '인도' }
  ];

  const categories = [
    { id: '', name: '전체' },
    { id: '1', name: '영화 및 애니메이션' },
    { id: '2', name: '자동차' },
    { id: '10', name: '음악' },
    { id: '15', name: '애완동물 및 동물' },
    { id: '17', name: '스포츠' },
    { id: '19', name: '여행 및 이벤트' },
    { id: '20', name: '게임' },
    { id: '22', name: '인물 및 블로그' },
    { id: '23', name: '코미디' },
    { id: '24', name: '엔터테인먼트' },
    { id: '25', name: '뉴스 및 정치' },
    { id: '26', name: '스타일 및 패션' },
    { id: '27', name: '교육' },
    { id: '28', name: '과학 및 기술' },
    { id: '29', name: '비영리 및 활동' },
    { id: '30', name: '영화' },
    { id: '31', name: '애니메이션' },
    { id: '32', name: '액션 및 모험' },
    { id: '33', name: '클래식' },
    { id: '34', name: '코미디' },
    { id: '35', name: '다큐멘터리' },
    { id: '36', name: '드라마' },
    { id: '37', name: '가족' },
    { id: '38', name: '외국' },
    { id: '39', name: '공포' },
    { id: '40', name: '공상과학 및 판타지' },
    { id: '41', name: '스릴러' },
    { id: '42', name: '단편' },
    { id: '43', name: '쇼' },
    { id: '44', name: '트레일러' }
  ];

  const sortOptions = [
    { value: 'relevance', label: '관련성 순' },
    { value: 'subscribers', label: '구독자수 많은순' },
    { value: 'views', label: '총조회수 많은순' }
  ];

  const dataSourceOptions = [
    { value: 'trending', label: '인기동영상 채널 기준' },
    { value: 'all', label: '전체 동영상 채널 기준' }
  ];

  // YouTube API 엔드포인트 옵션
  const endpointOptions = [
    { value: 'videos', label: 'Videos (동영상)' },
    { value: 'search', label: 'Search (검색)' },
    { value: 'channels', label: 'Channels (채널)' },
    { value: 'playlists', label: 'Playlists (재생목록)' },
    { value: 'playlistItems', label: 'Playlist Items (재생목록 항목)' },
    { value: 'commentThreads', label: 'Comment Threads (댓글)' },
    { value: 'videoCategories', label: 'Video Categories (동영상 카테고리)' }
  ];

  // Part 옵션
  const partOptions = [
    { value: 'snippet', label: 'Snippet (기본 정보)' },
    { value: 'statistics', label: 'Statistics (통계)' },
    { value: 'contentDetails', label: 'Content Details (상세 정보)' },
    { value: 'status', label: 'Status (상태)' },
    { value: 'brandingSettings', label: 'Branding Settings (브랜딩 설정)' },
    { value: 'topicDetails', label: 'Topic Details (주제 상세)' },
    { value: 'snippet,statistics', label: 'Snippet + Statistics' },
    { value: 'snippet,statistics,contentDetails', label: 'Snippet + Statistics + Content Details' },
    { value: 'snippet,statistics,brandingSettings,contentDetails', label: 'All Parts' }
  ];

  // Order 옵션
  const orderOptions = [
    { value: 'relevance', label: 'Relevance (관련성)' },
    { value: 'date', label: 'Date (날짜)' },
    { value: 'rating', label: 'Rating (평점)' },
    { value: 'title', label: 'Title (제목)' },
    { value: 'videoCount', label: 'Video Count (동영상 수)' },
    { value: 'viewCount', label: 'View Count (조회수)' }
  ];

  // Video Type 옵션
  const videoTypeOptions = [
    { value: 'video', label: 'Video (동영상)' },
    { value: 'channel', label: 'Channel (채널)' },
    { value: 'playlist', label: 'Playlist (재생목록)' }
  ];

  // Chart 옵션
  const chartOptions = [
    { value: 'mostPopular', label: 'Most Popular (가장 인기있는)' }
  ];

  // Video Duration 옵션
  const videoDurationOptions = [
    { value: '', label: '모든 길이' },
    { value: 'short', label: 'Short (4분 미만)' },
    { value: 'medium', label: 'Medium (4-20분)' },
    { value: 'long', label: 'Long (20분 이상)' }
  ];

  // Video Definition 옵션
  const videoDefinitionOptions = [
    { value: '', label: '모든 화질' },
    { value: 'high', label: 'High (고화질)' },
    { value: 'standard', label: 'Standard (표준화질)' }
  ];

  // Video Caption 옵션
  const videoCaptionOptions = [
    { value: '', label: '모든 자막' },
    { value: 'any', label: 'Any (모든)' },
    { value: 'closedCaption', label: 'Closed Caption (자막 있음)' },
    { value: 'none', label: 'None (자막 없음)' }
  ];

  // Video License 옵션
  const videoLicenseOptions = [
    { value: '', label: '모든 라이선스' },
    { value: 'any', label: 'Any (모든)' },
    { value: 'creativeCommon', label: 'Creative Common' },
    { value: 'youtube', label: 'YouTube' }
  ];

  // Safe Search 옵션
  const safeSearchOptions = [
    { value: 'moderate', label: 'Moderate (보통)' },
    { value: 'none', label: 'None (없음)' },
    { value: 'strict', label: 'Strict (엄격)' }
  ];

  // Event Type 옵션
  const eventTypeOptions = [
    { value: '', label: '모든 이벤트' },
    { value: 'completed', label: 'Completed (완료됨)' },
    { value: 'live', label: 'Live (라이브)' },
    { value: 'upcoming', label: 'Upcoming (예정됨)' }
  ];

  // Channel Type 옵션
  const channelTypeOptions = [
    { value: '', label: '모든 채널' },
    { value: 'any', label: 'Any (모든)' },
    { value: 'show', label: 'Show (쇼)' }
  ];

  // Text Format 옵션
  const textFormatOptions = [
    { value: 'html', label: 'HTML' },
    { value: 'plainText', label: 'Plain Text' }
  ];

  // Moderation Status 옵션
  const moderationStatusOptions = [
    { value: '', label: '모든 상태' },
    { value: 'heldForReview', label: 'Held for Review (검토 대기)' },
    { value: 'likelySpam', label: 'Likely Spam (스팸 의심)' },
    { value: 'published', label: 'Published (게시됨)' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      const params = new URLSearchParams({
        region: formData.region,
        maxResults: formData.maxResults
      });
      
      if (formData.categoryId) {
        params.append('categoryId', formData.categoryId);
      }
      if (formData.searchKeyword) {
        params.append('searchKeyword', formData.searchKeyword);
      }
      if (formData.minSubscribers) {
        params.append('minSubscribers', formData.minSubscribers);
      }
      if (formData.minViews) {
        params.append('minViews', formData.minViews);
      }
      if (formData.sortBy) {
        params.append('sortBy', formData.sortBy);
      }
      if (formData.dataSource) {
        params.append('dataSource', formData.dataSource);
      }
      
      // 새로운 동적 API 파라미터들 추가
      if (formData.endpoint) {
        params.append('endpoint', formData.endpoint);
      }
      if (formData.part) {
        params.append('part', formData.part);
      }
      if (formData.order) {
        params.append('order', formData.order);
      }
      if (formData.videoType) {
        params.append('videoType', formData.videoType);
      }
      if (formData.chart) {
        params.append('chart', formData.chart);
      }
      if (formData.videoDuration) {
        params.append('videoDuration', formData.videoDuration);
      }
      if (formData.videoDefinition) {
        params.append('videoDefinition', formData.videoDefinition);
      }
      if (formData.videoCaption) {
        params.append('videoCaption', formData.videoCaption);
      }
      if (formData.videoLicense) {
        params.append('videoLicense', formData.videoLicense);
      }
      if (formData.safeSearch) {
        params.append('safeSearch', formData.safeSearch);
      }
      if (formData.relevanceLanguage) {
        params.append('relevanceLanguage', formData.relevanceLanguage);
      }
      if (formData.eventType) {
        params.append('eventType', formData.eventType);
      }
      if (formData.channelType) {
        params.append('channelType', formData.channelType);
      }
      if (formData.textFormat) {
        params.append('textFormat', formData.textFormat);
      }
      if (formData.moderationStatus) {
        params.append('moderationStatus', formData.moderationStatus);
      }
      
      const response = await fetch(`/api/youtube/channels?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || '채널 API 호출 실패');
      }

      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-youtube-channels-api-page">
      <h2>유튜브채널 API 관리</h2>
      
      <div className="form-section">
        <h3>채널 데이터 수집 설정</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="region">지역:</label>
            <select
              id="region"
              name="region"
              value={formData.region}
              onChange={handleInputChange}
              required
            >
              {regions.map(region => (
                <option key={region.code} value={region.code}>
                  {region.name} ({region.code})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="maxResults">최대 결과 수:</label>
            <input
              type="number"
              id="maxResults"
              name="maxResults"
              value={formData.maxResults}
              onChange={handleInputChange}
              min="1"
              max="50"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="categoryId">카테고리 (선택사항):</label>
            <select
              id="categoryId"
              name="categoryId"
              value={formData.categoryId}
              onChange={handleInputChange}
            >
              {categories.map(category => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="searchKeyword">검색 키워드 (선택사항):</label>
            <input
              type="text"
              id="searchKeyword"
              name="searchKeyword"
              value={formData.searchKeyword}
              onChange={handleInputChange}
              placeholder="채널명이나 키워드로 검색"
            />
          </div>

          <div className="form-group">
            <label htmlFor="minSubscribers">최소 구독자 수 (선택사항):</label>
            <input
              type="number"
              id="minSubscribers"
              name="minSubscribers"
              value={formData.minSubscribers}
              onChange={handleInputChange}
              placeholder="예: 10000"
              min="0"
            />
          </div>

          <div className="form-group">
            <label htmlFor="minViews">최소 총 조회수 (선택사항):</label>
            <input
              type="number"
              id="minViews"
              name="minViews"
              value={formData.minViews}
              onChange={handleInputChange}
              placeholder="예: 1000000"
              min="0"
            />
          </div>

          <div className="form-group">
            <label htmlFor="sortBy">정렬 기준:</label>
            <select
              id="sortBy"
              name="sortBy"
              value={formData.sortBy}
              onChange={handleInputChange}
            >
              {sortOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="dataSource">데이터 추출 방식:</label>
            <select
              id="dataSource"
              name="dataSource"
              value={formData.dataSource}
              onChange={handleInputChange}
            >
              {dataSourceOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* YouTube API 동적 설정 섹션 */}
          <div className="form-section-divider">
            <h4>YouTube API 동적 설정</h4>
          </div>

          <div className="form-group">
            <label htmlFor="endpoint">API 엔드포인트:</label>
            <select
              id="endpoint"
              name="endpoint"
              value={formData.endpoint}
              onChange={handleInputChange}
            >
              {endpointOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="part">응답 파트:</label>
            <select
              id="part"
              name="part"
              value={formData.part}
              onChange={handleInputChange}
            >
              {partOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="order">정렬 순서:</label>
            <select
              id="order"
              name="order"
              value={formData.order}
              onChange={handleInputChange}
            >
              {orderOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="videoType">비디오 타입:</label>
            <select
              id="videoType"
              name="videoType"
              value={formData.videoType}
              onChange={handleInputChange}
            >
              {videoTypeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="chart">차트 타입:</label>
            <select
              id="chart"
              name="chart"
              value={formData.chart}
              onChange={handleInputChange}
            >
              {chartOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="videoDuration">동영상 길이:</label>
            <select
              id="videoDuration"
              name="videoDuration"
              value={formData.videoDuration}
              onChange={handleInputChange}
            >
              {videoDurationOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="videoDefinition">동영상 화질:</label>
            <select
              id="videoDefinition"
              name="videoDefinition"
              value={formData.videoDefinition}
              onChange={handleInputChange}
            >
              {videoDefinitionOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="videoCaption">자막 설정:</label>
            <select
              id="videoCaption"
              name="videoCaption"
              value={formData.videoCaption}
              onChange={handleInputChange}
            >
              {videoCaptionOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="videoLicense">라이선스:</label>
            <select
              id="videoLicense"
              name="videoLicense"
              value={formData.videoLicense}
              onChange={handleInputChange}
            >
              {videoLicenseOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="safeSearch">안전 검색:</label>
            <select
              id="safeSearch"
              name="safeSearch"
              value={formData.safeSearch}
              onChange={handleInputChange}
            >
              {safeSearchOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="relevanceLanguage">관련 언어:</label>
            <input
              type="text"
              id="relevanceLanguage"
              name="relevanceLanguage"
              value={formData.relevanceLanguage}
              onChange={handleInputChange}
              placeholder="예: ko, en, ja"
            />
          </div>

          <div className="form-group">
            <label htmlFor="eventType">이벤트 타입:</label>
            <select
              id="eventType"
              name="eventType"
              value={formData.eventType}
              onChange={handleInputChange}
            >
              {eventTypeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="channelType">채널 타입:</label>
            <select
              id="channelType"
              name="channelType"
              value={formData.channelType}
              onChange={handleInputChange}
            >
              {channelTypeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="textFormat">텍스트 형식:</label>
            <select
              id="textFormat"
              name="textFormat"
              value={formData.textFormat}
              onChange={handleInputChange}
            >
              {textFormatOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="moderationStatus">검토 상태:</label>
            <select
              id="moderationStatus"
              name="moderationStatus"
              value={formData.moderationStatus}
              onChange={handleInputChange}
            >
              {moderationStatusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isLoading}
          >
            {isLoading ? '처리 중...' : '채널 데이터 수집'}
          </button>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>API 오류 발생</h3>
          <div className="error-message">
            {error}
          </div>
        </div>
      )}

      {result && (
        <div className="result-section">
          <h3>API 호출 결과</h3>
          <div className="result-summary">
            <p><strong>지역:</strong> {result.region}</p>
            <p><strong>처리된 채널 수:</strong> {result.processedCount}</p>
            <p><strong>성공:</strong> {result.success ? '예' : '아니오'}</p>
            <p><strong>메시지:</strong> {result.message}</p>
          </div>

          {result.channels && result.channels.length > 0 && (
            <div className="channels-list">
              <h4>수집된 채널 목록</h4>
              <div className="channels-grid">
                {result.channels.map((channel, index) => (
                  <div key={index} className="channel-item">
                    <div className="channel-thumbnail">
                      <img 
                        src={channel.thumbnailUrl || '/default-channel-avatar.png'} 
                        alt={channel.title}
                        onError={(e) => {
                          e.target.src = '/default-channel-avatar.png';
                        }}
                      />
                    </div>
                    <div className="channel-info">
                      <h5>{channel.title}</h5>
                      <p className="subscribers">구독자: {channel.subscriberCount?.toLocaleString() || 'N/A'}</p>
                      <p className="views">총 조회수: {channel.viewCount?.toLocaleString() || 'N/A'}</p>
                      <p className="videos">동영상 수: {channel.videoCount?.toLocaleString() || 'N/A'}</p>
                      <p className="category">카테고리: {channel.categoryTitle || 'N/A'}</p>
                      <p>국가: {channel.country || 'N/A'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="info-section">
        <h3>사용법 안내</h3>
        <ul>
          <li>이 도구는 선택한 방식에 따라 채널 정보를 수집하여 youtube_channels 테이블에 저장합니다.</li>
          <li><strong>인기동영상 채널 기준:</strong> 해당 지역의 인기 동영상에서 채널 정보를 추출합니다.</li>
          <li><strong>전체 동영상 채널 기준:</strong> 전체 YouTube 채널 데이터베이스에서 조건에 맞는 채널을 검색합니다.</li>
          <li>지역을 선택하면 해당 지역의 데이터를 대상으로 합니다.</li>
          <li>카테고리를 선택하면 특정 카테고리의 동영상에서만 채널을 수집합니다.</li>
          <li>검색 키워드를 입력하면 해당 키워드와 관련된 동영상의 채널을 수집합니다.</li>
          <li>최소 구독자 수와 최소 총 조회수를 설정하여 조건에 맞는 채널만 필터링할 수 있습니다.</li>
          <li>정렬 기준을 선택하여 수집된 채널을 구독자수 또는 총조회수 순으로 정렬할 수 있습니다.</li>
          <li>최대 결과 수는 한 번에 수집할 채널의 개수를 제한합니다 (1-50개).</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminYoutubeChannelsApi;
